import { BaseModel } from './base.model';
import { DynamicListFieldRawModel } from './dynamic-list-field-raw.model';
import { DynamicListFieldOptionsModel } from './dynamic-list-field-options.model';

export class DynamicListModel extends BaseModel {

    name: string;

    // Associations
    dyn_list_field_raw: DynamicListFieldRawModel[];
    dyn_list_field_options: DynamicListFieldOptionsModel[];

    // Auxiliars
    fields: any[];
    primary_id: number;

    static validate(list: DynamicListModel): boolean {
        return !!(list.name);
    }

    constructor(list?: DynamicListModel) {
        super();

        this.name = list ? list.name || null : null;

        this.dyn_list_field_raw = list ? list.dyn_list_field_raw || [] : [];
        this.dyn_list_field_options = list ? list.dyn_list_field_options || [] : [];

        this.fields = list ? list.fields || [] : [];
        this.primary_id = list ? list.primary_id || null : null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/model/dynamic-list.model.ts